export default "__VITE_ASSET__DCFCKkN3__"